import { cmsAxiosInstance } from '../configuration/axiosConfig';
import { ClientResponse } from '../model/ClientResponse';
import Prirucka from '../model/Prirucka';
import PriruckaRiadok from '../model/PriruckaRiadok';

export const getPouzivatelskePrirucky = async ():
  Promise<ClientResponse<Prirucka[]>> => {
  const {
    data,
    status,
  } = await cmsAxiosInstance.get(
    '/pouzivatelske-prirucky?limit=100',
  );

  const getRiadkyBySekciaName = (nodeName: string):PriruckaRiadok[] => {
    const sekciaRiadkyNode = data.results
      // eslint-disable-next-line max-len
      .find((node) => node['@path'] === `/pouzivatelske-prirucky/pouzivatelske-prirucky/0/pouzivatelske-prirucky-sekcie/${nodeName}/pouzivatelske-prirucky-riadky`);
    const riadkyNodes = Object.keys(sekciaRiadkyNode)
      .filter((key) => /^\d+$/.test(key))
      .map((key) => sekciaRiadkyNode[key]);
    const mappedRiadky = riadkyNodes.map((riadok) => {
      const priruckaRiadok: PriruckaRiadok = {
        id: riadok['@id'],
        hodnotaStlpecPrvy: riadok.hodnotaStlpecPrvy,
        hodnotaStlpecDruhy: riadok.hodnotaStlpecDruhy,
        hodnotaStlpecTreti: riadok.hodnotaStlpecTreti,
      };
      return priruckaRiadok;
    });
    return mappedRiadky;
  };

  const pouzivatelskePriruckySekcieNode = data.results
    .find((node) => node['@name'] === 'pouzivatelske-prirucky-sekcie');

  const sekcieNodes = Object.keys(pouzivatelskePriruckySekcieNode)
    .filter((key) => /^\d+$/.test(key))
    .map((key) => pouzivatelskePriruckySekcieNode[key]);

  const mappedSekcie = sekcieNodes.map((sekcia) => {
    const priruckaSekcia: Prirucka = {
      id: sekcia['@id'],
      nazovStlpecPrvy: sekcia.nazovStlpecPrvy,
      nazovStlpecDruhy: sekcia.nazovStlpecDruhy,
      nazovStlpecTreti: sekcia.nazovStlpecTreti,
      nazov: sekcia.nazovSekcie,
      popis: sekcia.popisSekcie,
      nodeName: sekcia['@name'],
      roles: sekcia?.rolyPreSekciu?.split(', '),
      riadky: getRiadkyBySekciaName(sekcia['@name']),
    };
    return priruckaSekcia;
  });

  return {
    data: mappedSekcie,
    responseCode: status,
  };
};
